import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { StatusChipComponent } from '@components/status-chip/status-chip.component';
import { MotifChipModule } from '@ey-xd/ng-motif';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-request-status-column',
  standalone: true,
  imports: [MotifChipModule, StatusChipComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './request-status-column.component.html',
})
export class RequestStatusColumnComponent implements AgRendererComponent {
  readonly status = signal<number>(-1);

  private updateProperties(params: ICellRendererParams): void {
    this.status.set(params.data.requestStatus);
  }

  agInit(params: ICellRendererParams): void {
    this.updateProperties(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateProperties(params);
    return true;
  }
}
